export const IssueTypes = {
  CRITICAL: "Critical",
  SERIOUS: "Serious",
  MODERATE: "Moderate",
  MINOR: "Minor"
};

export const WCAGMapping = {
  wcag2a: "WCAG 2.0 A",
  wcag2aa: "WCAG 2.0 AA",
  wcag2aaa: "WCAG 2.0 AAA",
  wcag21a: "WCAG 2.1 A",
  wcag21aa: "WCAG 2.1 AA",
  wcag21aaa: "WCAG 2.1 AAA",
  wcag22a: "WCAG 2.2 A",
  wcag22aa: "WCAG 2.2 AA"
};
